export const SET_STANDARDSTATI = 'set_standardstati';
export const SET_STANDARDSTATI_LOADED = 'set_standardstati_loaded';

export const SET_STANDARDSUBSTATI = 'set_standardsubstati';
export const SET_STANDARDSUBSTATI_LOADED = 'set_standardsubstati_loaded';

export const SET_STANDARDTYPEN = 'set_standardtypen';
export const ADD_STANDARDTYP = 'add_standardtyp';
export const SET_STANDARDTYPEN_LOADED = 'set_standardtypen_loaded';

export const SET_STANDARDGRUPPEN = 'set_standardgruppen';
export const SET_STANDARDGRUPPEN_LOADED = 'set_standardruppen_loaded';

export const SET_STANDORTE = 'set_standorte';
export const SET_STANDORTE_LOADED = 'set_standorte_loaded';

export const SET_ANZAHL_STANDARD = 'set_anzahl_standard';

export const SET_STANDARD_KATEGORIEN = 'set_standard_kategorien';
export const SET_STANDARD_KATEGORIEN_LOADED = 'set_standard_kategorien_loaded';
